import React from 'react';

function PrimaryNavigation({ view, setView, isCoach, isPro }) {
  const navItems = [
    { id: 'dashboard', label: 'Player View', show: true },
    { id: 'teams', label: 'Coach View', show: isCoach },
    { id: 'pricing', label: 'Pricing', show: !isPro && !isCoach }
  ];

  return (
    <div className="primary-navigation">
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}>
        <nav style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'flex-start',
          marginLeft: '0'
        }}>
          {navItems.filter(item => item.show).map((item, index) => {
            const isActive =
              (item.id === 'dashboard' && !view.startsWith('team') && view !== 'pricing') ||
              (item.id === 'teams' && view.startsWith('team')) ||
              (item.id === 'pricing' && view === 'pricing');

            return (
              <button
                key={item.id}
                onClick={() => setView(item.id)}
                className={`primary-nav-item ${isActive ? 'active' : ''}`}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}

export default React.memo(PrimaryNavigation);
